import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectContactDirectoryLogicService } from './logic/project-contact-directory/project-contact-directory-logic.service';
import { ProjectContactDirectoryService } from './logic/project-contact-directory.service';
import { ProjectContactDirectoryDaoService } from './dao/project-contact-directory-dao.service';
import { ProjectContactDirectoryDbDaoService } from './dao/project-contact-directory-dao/project-contact-directory-db-dao.service';
import { ProjectContactDirectoryDbTableDefinition } from './dao/project-contact-directory-dao/project-contact-directory-db-table-definition';
import { LocalProjectContactDirectoryDbTableDefinition } from './dao/project-contact-directory-dao/local-project-contact-directory-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ProjectContactDirectoryService, useClass: ProjectContactDirectoryLogicService },
    { provide: ProjectContactDirectoryDaoService, useClass: ProjectContactDirectoryDbDaoService },
    { provide: ProjectContactDirectoryDbTableDefinition },
    { provide: LocalProjectContactDirectoryDbTableDefinition },
  ]
})
export class ProjectContactDirectoryModule {}
